const QUEBEC_STATE_VALUES = new Set(['QC', 'QUEBEC', 'QUÉBEC'])

export function isQuebecRestrictedState(state: string | null | undefined): boolean {
  if (state === null || state === undefined) return false
  return QUEBEC_STATE_VALUES.has(state.trim().toUpperCase())
}
